import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplashScreenComponent } from './splash-screen.component';
import { BrandLogoComponent } from "src/shared/brand-logo/brand-logo.component";

@NgModule({
  declarations: [SplashScreenComponent],
  imports: [
    BrandLogoComponent,CommonModule],
  exports: [SplashScreenComponent],
})
export class SplashScreenModule {}
